import styled from 'styled-components';

export const Root = styled.tbody`
  tr {
    :hover {
      background-color: ${({ theme }) => theme.colors.grey2};
    }
  }
`;
